import { DefaultApi, ApiResponse } from '../api';
import {
  AddDocumentPayload,
  CreatePasswordPayload,
  MaritalStatusData,
  SelfieAnalysisPayload,
} from '../types';

import { TRepresentative, SpouseDraft, SelfieAnalysis } from './types';

export const createSpouse = (representativeId: string, payload: SpouseDraft) =>
  DefaultApi.request<SpouseDraft>(
    `/representatives/${representativeId}/spouse`,
    {
      method: 'POST',
      data: payload,
    }
  );

export const createAccountPassword = (
  representativeId: string,
  payload: CreatePasswordPayload
) =>
  DefaultApi.request<ApiResponse<TRepresentative>>(
    `/representatives/${representativeId}/account-password`,
    {
      method: 'POST',
      data: payload,
    }
  );

export const selfieAnalysis = (
  representativeId: string,
  payload: SelfieAnalysisPayload
) =>
  DefaultApi.request<ApiResponse<SelfieAnalysis>>(
    `/representatives/${representativeId}/selfie-analysis`,
    {
      method: 'POST',
      data: payload,
    }
  );

export const addDocument = (
  representativeId: string,
  payload: AddDocumentPayload
) =>
  DefaultApi.request<ApiResponse<TRepresentative>>(
    `/representatives/${representativeId}/documents`,
    {
      method: 'POST',
      data: payload,
    }
  );

export const authorizeTake = (representativeId: string) =>
  DefaultApi.request<void>(
    `/representatives/${representativeId}/take-authorization`,
    { method: 'POST' }
  );

export const getRepresentativeById = (representativeId: string) =>
  DefaultApi.request<ApiResponse<TRepresentative>>(
    `/representatives/${representativeId}`,
    {
      method: 'GET',
    }
  );

export const sendSMS = (id: string, type: 'representative' | 'spouse') =>
  DefaultApi.post(`/${type}s/${id}/send-transhipment-link`);

export const addMaritalStatus = (
  representativeId: string,
  payload: MaritalStatusData
) =>
  DefaultApi.request(`/representatives/${representativeId}/marital-status`, {
    method: 'POST',
    data: payload,
  });
